import { getUserFunctionTree } from '@/layouts/header/api';
import { getEncrypt } from '@/constants/authConfig';
import { RULE_TYPE } from '@/constants/ruleConfig';
import store from '@/store/index';
import { deletePropertyFromTree } from 'ifs-utils';
import { getToken, setToken } from '../../utils/auth';
import { login, resetLogin, organizationCorpCustomerList } from '../../pages/login/api/auth/index';
import { SET_TOKEN, SET_USER_DATA } from '../types/mutations';

const defaultMenuData = [
    {
        children: [],
        name: '实名认证',
        path: '/authentication'
    }
];

export default {
    namespaced: true,
    state: {
        token: getToken(),
        userId: undefined,
        unifyId: undefined,
        userName: undefined,
        admin: undefined,
        companyType: undefined,
        customerId: undefined,
        account: undefined,
        mobile: undefined,
        realName: undefined,
        accountId: undefined,
        menuData: undefined,
        accountName: undefined,
        tenantId: undefined,
        tenantName: undefined,
        customerCode: undefined,
        corpName: undefined,
        creditCode: undefined,
        customers: undefined,
        projectIds: undefined,
        customerName: undefined,
        buttonPermission: undefined
    },
    mutations: {
        [SET_USER_DATA](state, [key, payload]) {
            state[key] = payload;
        },
        [SET_TOKEN](state, token) {
            state.token = token;
            setToken(token);
        },
        SET_BUTTON_PERMISSION(state, list) {
            const STATE = state;
            STATE.buttonPermission = list;
        },
        SET_ACCOUNTID(state, data) {
            const STATE = state;
            STATE.accountId = data;
        },
        SET_ACCOUNTNAME(state, data) {
            const STATE = state;
            STATE.accountName = data;
        },
        SET_MOBILE(state, data) {
            const STATE = state;
            STATE.mobile = data;
        },
        SET_CUSTOMER_CODE(state, data) {
            const STATE = state;
            STATE.customerCode = data;
        },
        SET_TENANT_ID(state, data) {
            const STATE = state;
            STATE.tenantId = data;
        },
        SET_USER_ID(state, data) {
            const STATE = state;
            STATE.userId = data;
        }
    },
    actions: {
        initSelect({ commit, state }) {
            if (state.creditCode && state.customers.length !== 1) {
                const keys = ['tenantId', 'tenantName', 'customerId', 'customerCode', 'customerName', 'projectIds'];
                keys.forEach((item) => {
                    commit(SET_USER_DATA, [item, undefined]);
                });
            }
        },
        async login({ commit, state }, data) {
            console.log(11111);
            let token = null;
            let userId = null;
            let unifyId = null;
            let admin = null;
            let ext = null;
            if (data.type === 'unifyLogin') {
                token = data.token;
                userId = data.userId;
                unifyId = data?.unifyId;
                admin = data.admin;
                ext = data.ext;
            } else if (data.type === 'login') {
                const params = {
                    ...data.form,
                    password: getEncrypt(data.form.password),
                    ext: { source: 'ENTERPRISE_CUSTOMER' },
                    ignoreEncrypt: false
                };
                const res = await login(params);
                token = res.token;
                userId = res.userId;
                unifyId = res?.unifyId;
                admin = res.admin;
                ext = res.ext;
            } else {
                localStorage.removeItem('buttonPermission');
                const res = await resetLogin({ ...data.form, ext: { source: 'ENTERPRISE_CUSTOMER' } });
                token = res.token;
                userId = res.userId;
                unifyId = res?.unifyId;
                admin = res.admin;
                ext = res.extJSON;
            }
            console.log(333, ext);
            const { companyType, customerId, corpName, creditCode, account, mobile, realName, accountId, accountName, tenantId, customerCode, tenantName } = ext;
            commit(SET_TOKEN, token);
            commit(SET_USER_DATA, ['userId', userId]);
            commit(SET_USER_DATA, ['unifyId', unifyId]);
            commit(SET_USER_DATA, ['userName', data?.form?.userName]);
            commit(SET_USER_DATA, ['admin', admin]);
            commit(SET_USER_DATA, ['companyType', companyType === '企业' || !!creditCode]);
            commit(SET_USER_DATA, ['customerId', customerId]); // 货主id
            commit(SET_USER_DATA, ['account', account]); // 账号
            commit(SET_USER_DATA, ['mobile', mobile]); // 手机号
            commit(SET_USER_DATA, ['realName', realName]); // 账号名称
            commit(SET_USER_DATA, ['accountId', accountId]); // 账号id
            commit(SET_USER_DATA, ['accountName', accountName || corpName]); // 组织名称
            commit(SET_USER_DATA, ['customerCode', customerCode]); // 货主编码
            commit(SET_USER_DATA, ['tenantId', tenantId]); // 货主tenantId
            commit(SET_USER_DATA, ['tenantName', tenantName]); // 货主tenantId
            commit(SET_USER_DATA, ['corpName', corpName]); // 企业名称
            commit(SET_USER_DATA, ['creditCode', creditCode]); // 企业信用代码
            commit(SET_USER_DATA, ['customerName', undefined]); // 货主名称
            commit(SET_USER_DATA, ['customers', undefined]); // 绑定货主
            let customers = [];
            if (creditCode) {
                const res = await organizationCorpCustomerList({
                    accountId,
                    creditCode,
                    needChildren: true,
                    needOrgIdentity: true,
                    orgType: 'ORG',
                    needAccountIdentity: true,
                    orgStatus: 'ENABLED'
                });
                if (res) {
                    customers = res[0].children.map((item) => {
                        return {
                            customerId: item?.identityOrg?.identityId,
                            customerCode: item.ext?.customerCode,
                            customerName: item.name,
                            tenantId: item.ext?.carrierTenantId,
                            orgId: item.id
                        };
                    });
                }
                if (customers.length === 1) {
                    commit(SET_USER_DATA, ['customerCode', customers[0].customerCode]); // 货主编码
                    commit(SET_USER_DATA, ['tenantId', customers[0].tenantId]); // 货主tenantId
                    commit(SET_USER_DATA, ['customerId', customers[0].customerId]); // 货主id
                    const accountData = {
                        id: customers[0].orgId,
                        identityId: customers[0].customerCode
                    };
                    localStorage.setItem('accountData', JSON.stringify(accountData));
                }
                commit(SET_USER_DATA, ['customers', customers]); // 绑定货主
            }
            // 没有货主customerId就使用默认菜单
            if (!customerId && !creditCode) {
                commit(SET_USER_DATA, ['menuData', defaultMenuData]);
                commit(SET_USER_DATA, ['companyType', true]);
            } else {
                let menuData = await getUserFunctionTree({
                    accountId: userId,
                    objId: state.customerId,
                    admin,
                    systemCode: 'customer',
                    functionTypes: ['MODULE', 'MENU'],
                    status: 'ENABLED',
                    objIds: (state.customers || []).map((item) => item.customerId)
                });
                menuData.sort((val1, val2) => val1.order - val2.order);
                if (customers.length > 1) {
                    menuData = menuData.map((item) => {
                        if (item.path === '/setting') {
                            return {
                                ...item,
                                children: item.children
                                // children:item.children.filter(child=>child.path!=='/account')
                            };
                        }
                        return { ...item };
                    });
                }
                deletePropertyFromTree(menuData, 'ext.version', '1.0'); // 过滤新版本菜单
                commit(SET_USER_DATA, ['menuData', menuData]); // 菜单数据
            }
            store.dispatch('orderRules/getOrderCrop', RULE_TYPE.sensitiveFields);
        },
        loginFromMainApp({ commit }, loginData) {
            // 从主应用直接获取登录数据
            return new Promise((resolve) => {
                const { token, userId, unifyId, admin, ext } = loginData;
                const { companyType, customerId, corpName, creditCode, account, mobile, realName, accountId, accountName, tenantId, customerCode } = ext;
                commit(SET_TOKEN, token);
                commit(SET_USER_DATA, ['userId', userId]);
                sessionStorage.setItem('userId', userId);
                commit(SET_USER_DATA, ['unifyId', unifyId]);
                commit(SET_USER_DATA, ['userName', loginData?.loginUserName]);
                commit(SET_USER_DATA, ['admin', admin]);
                commit(SET_USER_DATA, ['companyType', companyType === '企业' || !!creditCode]);
                commit(SET_USER_DATA, ['customerId', customerId]); // 货主id
                commit(SET_USER_DATA, ['account', account]); // 账号
                commit(SET_USER_DATA, ['mobile', mobile]); // 手机号
                commit(SET_USER_DATA, ['realName', realName]); // 账号名称
                commit(SET_USER_DATA, ['accountId', accountId]); // 账号id
                commit(SET_USER_DATA, ['accountName', accountName || corpName]); // 组织名称
                commit(SET_USER_DATA, ['customerCode', customerCode]); // 货主编码
                commit(SET_USER_DATA, ['tenantId', tenantId]); // 货主tenantId
                commit(SET_USER_DATA, ['corpName', corpName]); // 企业名称
                commit(SET_USER_DATA, ['creditCode', creditCode]); // 企业信用代码
                commit(SET_USER_DATA, ['customerName', undefined]); // 货主名称
                commit(SET_USER_DATA, ['customers', undefined]); // 绑定货主
                let customers = [];
                if (creditCode) {
                    customers = loginData.organizationCorpCustomerList;
                    if (customers.length === 1) {
                        commit(SET_USER_DATA, ['customerCode', customers[0].customerCode]); // 货主编码
                        commit(SET_USER_DATA, ['tenantId', customers[0].tenantId]); // 货主tenantId
                        commit(SET_USER_DATA, ['customerId', customers[0].customerId]); // 货主id
                        const accountData = {
                            id: customers[0].orgId,
                            identityId: customers[0].customerCode
                        };
                        localStorage.setItem('accountData', JSON.stringify(accountData));
                    }
                    commit(SET_USER_DATA, ['customers', customers]); // 绑定货主
                }
                // 没有货主customerId就使用默认菜单
                if (!customerId && !creditCode) {
                    commit(SET_USER_DATA, ['menuData', defaultMenuData]);
                    commit(SET_USER_DATA, ['companyType', true]);
                } else {
                    let menuData = loginData.originMenuList;
                    menuData.sort((val1, val2) => val1.order - val2.order);
                    if (customers.length > 1) {
                        menuData = menuData.map((item) => {
                            if (item.path === '/setting') {
                                return {
                                    ...item,
                                    children: item.children
                                    // children:item.children.filter(child=>child.path!=='/account')
                                };
                            }
                            return { ...item };
                        });
                    }
                    commit(SET_USER_DATA, ['menuData', menuData]); // 菜单数据
                }
                store.dispatch('orderRules/getOrderCrop', RULE_TYPE.sensitiveFields);
                resolve();
            });
        }
    }
};
